var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    _vm._g(
      _vm._b(
        {
          ref: "modal",
          attrs: {
            closable: true,
            okBtnAction: _vm.okBtnAction,
            hasCancelBtn: false,
          },
          on: { onOkClick: _vm.okOnClick },
        },
        "HKLModal",
        _vm.proxyAttrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("template", { slot: "title" }, [
        _c("div", { domProps: { innerHTML: _vm._s(_vm.modalTitle) } }),
      ]),
      _vm._v(" "),
      _vm.status === _vm.ACCEPT_STATUS.NO_TENANT_ACCEPT
        ? _c("img", {
            directives: [
              {
                name: "region-img-src",
                rawName: "v-region-img-src",
                value: "wp-no-tenant.png",
                expression: "'wp-no-tenant.png'",
              },
            ],
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }